<template>
  <div id="app" class="vue-page" >
    <div class="mm-layout" :class="{'menu-opened': openedMobileMenu}">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { GlobalListenersManager } from './services/MapsfyApi'
export default {
  data() {
    return {
      globalListenersManager: new GlobalListenersManager(this.$store)
    }
  },
  mounted() {
    this.globalListenersManager.createListeners();
  },
  beforeDestroy() {
    this.globalListenersManager.removeListeners();
  },
  computed: {
    openedMobileMenu() {
      return this.$store.getters['ui/openedMobileMenu'];
    }
  }
}
</script>

<style>
.home-page {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*
  text-align: center;
  color: #2c3e50;
  */
  margin: 0;
  /*overflow-y: auto !important;*/



    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2000;

}

html {
  font-size: 10px;
  overflow-y: auto;
}
</style>
